var base = require('settings/api/tokens');

Vue.component('spark-tokens', {
    mixins: [base],

    methods: {
        /**
         * Overwritten to fix the deprecated _.contains method of lodash.
         * Determine if the ability has been assigned to the token being edited.
         */
        abilityIsAssigned(ability) {
            return _.includes(this.updateTokenForm.abilities, ability);
        },
    }
});
